import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAssetError, setTransferAssetDetails } from "Store/AssetManagement/AssetNumber/AssetNumberAction";
import TransferAction from "Store/Component/Transfer/TransferAction";
import { formatPrice, getFileName } from "utils";
import { v1 as uuid } from "uuid";
import Informations from "./AssetInformation"
import UploadAttachmentsDispatch from "Store/AssetManagement/UploadAttachments/UploadAttachmentsDispatch";
import { IAssets } from "Model/IAssets";
import { useParams } from "react-router-dom";
import { CONSTANTS } from "client/utils/constants";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import ConfirmationBee from "../../../../../../../assets/images/ConfirmationBee.svg";
import dispositionValidation from '../../Disposition/dispositionValidation';
import Moment from 'moment';
import { getDispositionPenaltyFee, getPenaltyGlobalFlag, setDispositionPenaltyFee } from "Store/OrderManagement/DispositionPenaltyFee/DispositionPenaltyFeeAction";
import { getDispositionChoice } from "Store/OrderManagement/DispositionChoice/DispositionChoiceAction";


//There is one interface for asset "IAsset", but for checking updated fields, only below fields are required.
//Thats why created this const array for checking 
const assetFieldList = [
  'assetNumber',
  'odometerHourMeter',
  'estimatedDispositionPrice',
  'conditionRating',
  'conditionComment'
]
const InformationContainer = (props: any) => {

  const {
    isRevertChanges ,
    initialState,
    setAssetDetailList,
    assetDetailList,
    setTotalPenaltyFee,
    totalPenaltyFee,
    setShoweExemptionFields
  } = props;
  const wrapperRef = useRef<any>(null);
  const dispatch = useDispatch();
  const dispatchUploadAttachments =
    UploadAttachmentsDispatch.dispatchUploadAttachments(dispatch);
  const dispatchRemoveAttachment = UploadAttachmentsDispatch.dispatchRemoveAttachment(dispatch);
  const [isAssetNumberValid, setIsAsserNumberValid] = useState(false);
  const [showWarningPopupOnUpdate, setShowWarningPopupOnUpdate] = useState<any>(false);
  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
  });
  const [WarningPopupcontent, setWarningPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
  });
  const [attachmentsList, setAttachmentsList] = useState<any>([]);
  const [isAttachmentBtnClicked, setIsAttachmentBtnClicked] = useState<any>([]);
  const [list, setList] = useState<any>([]);
  const [error, setError] = useState<string>("");
  const [addNewAssetAlert, setAddNewAssetAlert] = useState(false)
  const [isGetAssetInfoCicked, setIsGetAssetInfoClicked] = useState(false)
  const DispositionAssetFieldRef = useRef<any>([]);
  const [isAssetBtnClicked, setIsAssetBtnClicked] = useState(false)
  const [isAddAssetClicked, setIsAddAssetClicked] = useState(false)
  const [showDispositionInfoAlert, setShowDispositionInfoAlert] = useState(false)

  const { 
    assetDetails, 
    assetError, 
    cartAssets, 
    docList, 
    dispositionData, 
    assets, 
    state, 
    dispositionPenaltyFee,
    globalPenaltyFlag
  }: any = useSelector((state?: any) => ({    
    assetDetails: state.AssetNumber.assetDetails,
    assetError: state.AssetNumber.assetError,
    cartAssets: state.TransferReducer.cartAssets,
    docList: state.UploadAttachmentsReducer.list,
    dispositionData: state.TransferReducer.dispositionList,
    assets: state.TransferReducer.assets,
    state: state,
    dispositionPenaltyFee: state.DispositionPenaltyFeeReducer.dispositionPenaltyFee,
    globalPenaltyFlag: state.DispositionPenaltyFeeReducer.globalPenaltyFlag
  }));

  const hideDialogAsset = () => {
    setAddNewAssetAlert(false)
  }
  
  const hideDialogAddDisposition = () => {
    setShowDispositionInfoAlert(false)
  }

  let { id } = useParams();

  useEffect(() => {
    DispositionAssetFieldRef?.current[0]?.focus();
  }, [])

  useEffect(() => {
    setTimeout(() => {
      setAddNewAssetAlert(false)
    }, 3000)
  }, [addNewAssetAlert])

  useEffect(() => {
    setAttachmentsList(docList);
    setList(docList)
    if (docList?.length > 0 && dispositionData?.length) {
      dispatch(TransferAction.setIDisposition({ ...dispositionData, uploadAttachmentsError: '' }))
    }
  }, [docList])

  useEffect(() => {
    if (dispositionData?.length) {
    dispatch(TransferAction.setIDisposition({ ...dispositionData, uploadAttachmentsError: '' }))
    }
  }, [dispositionData?.assetDispositionChoice])

  useEffect(() => {
    let isUpdated = false;
    assetDetailList.forEach((item: any) => {
      const findAsset = assets?.filter((i: any) => i?.assetNumber === item?.assetNumber);
      if (findAsset?.length > 0) {
        const tempAsset = findAsset[0];
        assetFieldList.forEach(element => {
          if (item[element] != tempAsset[element]) {
            isUpdated = true;
          }
        })
        if (item?.attachments?.length != tempAsset?.attachments?.length) {
          isUpdated = true
        }
      } else {
        isUpdated = true;
      }
    });
    dispatch(TransferAction.setIsCartNotUpdated(isUpdated));
  }, [assetDetailList])

  useEffect(() => {
    let tempAssets = assetDetailList?.length > 0 ? assetDetailList : [];
    
    //check if asset exist in cart
    cartAssets?.forEach((asset: any) => {
      tempAssets.forEach((childAsset: any) => {
        if (childAsset?.assetNumber === asset?.assetNumber) {
          childAsset.isExist = asset.isExist;
          // sync assetError from cartAssets so submit-time validation errors appear in the Asset# input
          if (asset.assetError !== undefined) {
            childAsset.assetError = asset.assetError;
          }
        }
      });
    });

    //delete asset from list when deleted from cart
    if (cartAssets?.length === assets?.length && assets.length != assetDetailList?.length) {
      const newTempAsset = JSON.parse(JSON.stringify(tempAssets))
      tempAssets = [];
      cartAssets?.forEach((asset: any) => {
        const temp = newTempAsset.filter((item: any) => item?.assetNumber === asset?.assetNumber);
        if (temp) {
          tempAssets.push(temp[0]);
        }
      });
    }

    setAssetDetailList(tempAssets);

  }, [cartAssets])

  useEffect(() => {
    let tempAssets = assetDetailList?.length > 0 ? assetDetailList : [];
    tempAssets.forEach((asset: any) => {
      let temp = Validate(asset);
      asset.isAttachmentsRequired = temp?.asset?.isAttachmentsRequired
      asset.isValid = temp.isValid;
    });
    setAssetDetailList(tempAssets);
    updateAllState()
  }, [JSON.stringify(dispositionData)])

  useEffect(() => {
    if (id) {
      setIsGetAssetInfoClicked(true)
      updateAllState();    
    } else {
      let assetDetailListTemp = [];
      for (let i = 1; i <= props.quantity; i++) {
        const asset: IAssets = JSON.parse(JSON.stringify(initialState));
        asset.assetIndex = i;
        assetDetailListTemp.push(asset);
      }
      setAssetDetailList(assetDetailListTemp);
      dispatch(getPenaltyGlobalFlag()) 
    }
  }, [])

  useEffect(() => {
    if (isRevertChanges) {
      updateAllState();
    }
  }, [isRevertChanges])

  useEffect(()=>{
    if(showDispositionInfoAlert){
      setTimeout(()=>{
        setShowDispositionInfoAlert(false)
      },30000)
    }
  }, [showDispositionInfoAlert])

  const updateAllState = () => {
    let assetDetailListTemp: any = [];
    let assetsListTemp = assets?.length > 0 ? JSON.parse(JSON.stringify(assets)) : []
    assetsListTemp.forEach((asset: any, index: any) => {
      asset.assetIndex = index;
      assetDetailListTemp.push(asset);
    });
    if(assetsListTemp.length === 0){
      for (let i = 1; i <= props.quantity; i++) {
        const asset: IAssets = JSON.parse(JSON.stringify(initialState));
        asset.assetIndex = i;
        assetDetailListTemp.push(asset);
      }  
    } else {
      props.setShowDispositionInformation(true)
    }
    dispatch(TransferAction.setAssetData(assetsListTemp));
    setAssetDetailList(assetDetailListTemp);
  };

  const setAssetDetailsItem = (assetDetailListTemp?: any) => {
    assetDetailListTemp?.forEach((assetItem: any) => {
      if (assetItem?.assetNumber === assetDetails?.assetNumber?.toString()) {

        assetItem.assetError = "";
        assetItem.unitNumber = assetDetails.unitNumber;
        assetItem.modelYear = assetDetails.modelYear;
        assetItem.color = assetDetails.color;
        assetItem.description = assetDetails.description;
        assetItem.serialNumber = assetDetails.serialNumber;
        assetItem.licensePlateNumber = assetDetails.licensePlateNumber;
        assetItem.monthlyAmount = assetDetails.monthlyAmount;
        assetItem.monthRemaining = assetDetails.monthRemaining;
        assetItem.equipmentClassDesc = (assetDetails?.equipmentClassDesc !== "-.") ? assetDetails?.equipmentClassDesc : "-";
        assetItem.eqStatusDesc = (assetDetails?.eqStatusDesc !== "-.") ? assetDetails?.eqStatusDesc : "-";
        assetItem.netBookedValue = assetDetails.netBookedValue;
        assetItem.glCategory = assetDetails.glCategory;
        assetItem.isOdometerRequired = assetDetails.isOdometerRequired;
        assetItem.dateAcquired = assetDetails.dateAcquired ? Moment(assetDetails.dateAcquired).format('MM/DD/YYYY') : '-';
        assetItem.disposeGainLoss = assetDetails?.disposeGainLoss;
        assetItem.acquisitionCode = assetDetails?.acquisitionCode;
        assetItem.accountObject = assetDetails?.accountObject;
        assetItem.acquisitionCost = assetDetails?.acquisitionCost;
        assetItem.lifeMonths = assetDetails?.lifeMonths;
        assetItem.leasedvsOwned = assetDetails?.leasedvsOwned;
        assetItem.showAssetStatus = assetDetails?.showAssetStatus;
        assetItem.dispositionPenalityFee = 0
        assetItem.manufacturerName = assetDetails?.manufacturerName;
        assetItem.model = assetDetails?.model;
      }
    });
    setAssetDetailList(assetDetailListTemp);
  }

  useEffect(() => {
    if (assetDetails?.assetNumber) {
      let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
      let count: any = [];
      assetDetailListTemp?.map((assetItem?: any) => {
        if (assetItem?.leasedvsOwned) {
          count.push(assetItem)
        }
      })
      if (count?.length == 0 || (count?.length == 1 && !dispositionData?.assetDispositionChoice)) {
        setAssetDetailsItem(assetDetailListTemp)
      } else {
        if (assetDetails?.leasedvsOwned == count[0]?.leasedvsOwned) {
          setAssetDetailsItem(assetDetailListTemp)

        } else {
          dispatch(setTransferAssetDetails({}));
          dispatch(setAssetError({ assetNumber: assetDetails?.assetNumber, assetError: "Please enter Valid Asset #" }))
          let decriptionTxt: any
          if (count[0]?.leasedvsOwned == CONSTANTS.OWNED) {
            decriptionTxt = (
              <div>
                <p>Please provide an asset that is an owned asset for this disposition choice</p>
              </div>
            );
          } else {
            decriptionTxt = (
              <div>
                <p>Please provide an asset that is an leased asset for this disposition choice</p>
              </div>
            );
          }

          setWarningPopupcontent({
            ...WarningPopupcontent,
            titleImg: ConfirmationBee,
            title: "Information",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: decriptionTxt,
            outlineBtnText: "OK",
            isSingleConfirmationBtn: true,
            popupOutlinebtnOnclick: () => {
              warningHideDialog();
            }
          });
        }
      }
    }
  }, [assetDetails])

  // Helper function to determine if field is Hour Meter or Mileage/Odometer 
  const isHourMeterField = (asset: any) => {
    if (asset.isOdometerRequired) {
      return false;
    }
    return asset?.glCategory?.toLowerCase()?.includes("mower");
  }

  const getOdometerLabel = (asset: any) => {
    let label;
    if (asset.isOdometerRequired) {
      label = "Mileage"
    } else if (asset.glCategory?.toLowerCase()?.includes("mower")) {
      label = "Hour Meter"
    } else if((asset?.assetNumber?.length && asset?.assetNumber && isAssetBtnClicked && !asset.assetError) || ( asset.isOdometerRequired === false) ){
      label = "Odometer / Meter"
    }else{
      label = "Odometer / Hour Meter"
    }
    return label
  }

  const getVinSerialLabel = (asset: any) => {
    let label = "";
    if (asset.isOdometerRequired && asset?.assetNumber && isAssetBtnClicked) {
      label = "Vin #"
    }else if((asset?.assetNumber && isAssetBtnClicked) || (asset.isOdometerRequired != undefined || asset.isOdometerRequired == false) ){
      label = "Serial #"
    }else{
      label = "VIN / Serial #"
    }
    return label;
  }


  const onChangeOdometerHourMeter = (item: any, asset: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    assetDetailListTemp.forEach((assetItem : any) => {
      if (assetItem.assetIndex === asset.assetIndex) {
        const value = item?.target?.value;
        // Different regex for Hour Meter (integer only) vs Mileage/Odometer (1 decimal)
        const hourMeterRegex = /^\d{0,9}$/; // Integer only for Hour Meter
        const odometerRegex = /^\d{0,8}(\.\d{0,1})?$/; // Up to 1 decimal for Mileage/Odometer
        const regex = isHourMeterField(assetItem) ? hourMeterRegex : odometerRegex;
        
        if (value === '' || regex.test(value)) {
          assetItem.odometerHourMeter = value;
          const errors = { ...validateOdometerHourMeter(assetItem) };
          assetItem.odometerHourMeterError = errors.odometerHourMeterError;
          assetItem.isValid = Validate(assetItem).isValid;
        }
        return
      }
    });
    setAssetDetailList(assetDetailListTemp)
  }

  const formatOdometerOnBlur = (event: any, asset: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    assetDetailListTemp.forEach((assetItem: any) => {
      if (assetItem.assetIndex === asset.assetIndex) {
        const value = event.target.value;
        if (value && value !== '') {
          if (isHourMeterField(assetItem)) {
            // Hour Meter: No formatting, keep as integer
            assetItem.odometerHourMeter = value;
          } else {
            assetItem.odometerHourMeter = parseFloat(value).toFixed(1);
          }
        }
      }
    });
    setAssetDetailList(assetDetailListTemp)
  }

  const priceFormat = (item: any, asset: any) => {
    if (item.target.value == 0)
      return
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    assetDetailListTemp.forEach((assetItem : any) => {
      if (assetItem.assetIndex === asset.assetIndex) {
        assetItem.estimatedDispositionPrice = formatPrice(item.target.value, 2);
      }
    });
    setAssetDetailList(assetDetailListTemp);
  };

  const onChangeEstimatedDispositionPrice = (item: any, asset: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    assetDetailListTemp.forEach((assetItem : any) => {
      if (assetItem.assetIndex === asset.assetIndex) {
        const regEx = /^\d{0,30}(\.\d{0,8})?$/;
        const valArr = item.target.value.split('.')
        const checkNumber = regEx.test(item.target.value);
        if (!checkNumber || valArr.length > 2) {
          return;
        }
        assetItem.estimatedDispositionPrice = item.target.value;
        const errors = { ...validateEstimatedDispositionPrice(assetItem) };
        assetItem.estimatedDispositionPriceError = errors.estimatedDispositionPriceError;
        assetItem.isValid = Validate(assetItem).isValid;
        return
      }
    });
    setAssetDetailList(assetDetailListTemp);
  }

  const onChangeOverallCondition = (item: any, rating: any, asset: any,) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    // const value = item?.target?.id.split("-")[2]
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    assetDetailListTemp.forEach((assetItem : any) => {
      if (assetItem.assetIndex === asset.assetIndex) {
        assetItem.conditionRating = rating;
        const errors = { ...validateOverallConditionComment(assetItem) };
        assetItem.overallConditionError = "";
        assetItem.overallConditionCommentError = errors.overallConditionCommentError;
        assetItem.isValid = Validate(assetItem).isValid;
        return
      }
    });
    setAssetDetailList(assetDetailListTemp);
  }

  const onChangeOverallConditionComment = (item: any, asset: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    assetDetailListTemp.forEach((assetItem : any) => {
      if (assetItem.assetIndex === asset.assetIndex) {
        assetItem.conditionComment = item.target.value;
        const errors = { ...validateOverallConditionComment(assetItem) };
        assetItem.overallConditionCommentError = errors.overallConditionCommentError;
        assetItem.isValid = Validate(assetItem).isValid;
        return
      }
    });
    setAssetDetailList(assetDetailListTemp);
  }

  useEffect(() => {
    let assetDetailListTemp = assetDetailList

    assetDetailListTemp.forEach((assetItem :any) => {
      if ((assetItem?.assetError == "" || assetItem?.assetError == undefined) && assetItem.glCategory === CONSTANTS.TRAILERS){
        assetItem.odometerHourMeter = "0";
      }
      else if(assetItem?.assetError !== undefined) {
          if(assetItem?.glCategory === "Trailers"){
            assetItem.glCategory = ""
          }
      }
    })
  }, [assetError])

  const warningHideDialog = () => {
    setWarningPopupcontent({ ...WarningPopupcontent, isDialogVisible: false })
  }

  const isValidForPenaltyFee = (selectedOption?: any) => {
    if (selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_NO_TITLE || 
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_NO_TITLE ||
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_TITLED || 
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_TITLED) {
      return true
    } else {
      return false
    }
  }

  const updateAsset = (assetDetailListTemp?: any) => {
    props.setShowDispositionInformation(true)
    setIsAddAssetClicked(false);
    setShowDispositionInfoAlert(true)
    props?.setUpdateCartRef(true)
    dispositionPenaltyFee?.forEach((feeValue: any) => {
      assetDetailListTemp?.forEach((assetDetailItem?: any) => {
        if (feeValue?.assetNumber == assetDetailItem?.assetNumber) {
          assetDetailItem.dispositionPenalityFee = feeValue?.penaltyFee
        }
      })
    })
    dispatch(TransferAction.setAssetData(assetDetailListTemp))
    setAssetDetailList(assetDetailListTemp)
  }

  useEffect(() => {
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : []
    if (dispositionPenaltyFee && showWarningPopupOnUpdate && isValidForPenaltyFee(dispositionData?.assetDispositionChoice)) {
      let fee = 0;
      dispositionPenaltyFee?.forEach((feeValue: any) => {
        fee = fee + feeValue?.penaltyFee
      })
      let totalPenaltyFeeTemp = 0;
      assetDetailListTemp?.forEach((assetItem?: any) => {
        totalPenaltyFeeTemp = totalPenaltyFeeTemp + assetItem.dispositionPenalityFee;
      })
      if (fee != 0 && totalPenaltyFeeTemp != fee) {
        setTotalPenaltyFee(fee);
        let decriptionTxt = (
          <div>
            <p>A ${parseFloat(`${fee}`).toFixed(2)} Penalty Fee will be assessed if you proceed with this Disposition Choice</p>
          </div>
        );
        setWarningPopupcontent({
          ...WarningPopupcontent,
          titleImg: ConfirmationBee,
          title: "Disposition Penalty Warning !",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: decriptionTxt,
          outlineBtnText: "No",
          primaryBtnText: "Yes",
          isSingleConfirmationBtn: false,
          popupOutlinebtnOnclick: () => {
            warningHideDialog();
            setShowWarningPopupOnUpdate(false);
            dispatch(setDispositionPenaltyFee([]))
          },
          popupPrimarybtnOnclick: () => {                                           
            updateAsset(assetDetailListTemp)
            setShoweExemptionFields(true)
            setShowWarningPopupOnUpdate(false)
            dispatch(setDispositionPenaltyFee([]))
            warningHideDialog();
          },
        });
      } else {
        updateAsset(assetDetailListTemp)
      }
      if(fee == 0 || fee == undefined || fee == null){
        setShoweExemptionFields(false)
    }
    }
  }, [dispositionPenaltyFee])


  const onClickAdd = () => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    let nextAssetIndex = 0;
    assetDetailListTemp.forEach((item: any) => {
      if (item.assetIndex > nextAssetIndex) {
        nextAssetIndex = item.assetIndex;
      }
    });
    nextAssetIndex = nextAssetIndex + 1;
    setAddNewAssetAlert(true)
    const asset: any = initialState;
    asset.assetIndex = nextAssetIndex;
    assetDetailListTemp.push(asset);
    setAssetDetailList(assetDetailListTemp);
    dispatch(TransferAction.setAssetData(assetDetailListTemp));
  }
  const hideDialog = () => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
  }
  const popupOutlinebtnOnclick = () => {
    hideDialog()
  };

  const onClickDelete = (asset: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    if (assetDetailList?.length == 1) {
      setTotalPenaltyFee(0)
      props.onCancelClick(true);
    } else {
      let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
      const removeList = assetDetailListTemp.find((item: any) => item.assetIndex == asset.assetIndex)
      let totalPenaltyFeeTemp = totalPenaltyFee - removeList?.dispositionPenalityFee;
      setTotalPenaltyFee(totalPenaltyFeeTemp)
      const list = assetDetailListTemp.filter((item: any) => item.assetIndex !== asset.assetIndex)
      setAssetDetailList(list);
      dispatch(TransferAction.setAssetData(list));
    }
  }

  const Validate = (assets: IAssets) => {
    let asset = JSON.parse(JSON.stringify(assets))
    asset.assetError = validateAsset(asset).isValid ? "" : validateAsset(asset).error.assetError;
    asset.odometerHourMeterError = validateOdometerHourMeter(asset).odometerHourMeterError;
    asset.estimatedDispositionPriceError = validateEstimatedDispositionPrice(asset).estimatedDispositionPriceError;
    asset.overallConditionCommentError = validateOverallConditionComment(asset).overallConditionCommentError;
    asset.overallConditionError = validateOverallCondition(asset).overallConditionError;
    asset.assetStatusError = validateAssetStatus(asset).assetStatusError

    let isValid = true;

    if (asset.assetError || asset.odometerHourMeterError || asset.estimatedDispositionPriceError || asset.overallConditionCommentError || asset.overallConditionError || (asset?.assetStatusError && asset?.showAssetStatus)) {
      isValid = false;
    }
    if (!dispositionValidation.choices.includes(dispositionData?.assetDispositionChoice)) {
      if (docList?.length < 0) {
        dispatch(TransferAction.setIDisposition({ ...dispositionData, uploadAttachmentsError: 'Please upload a file' }))
      }
      if (asset.attachments?.length <= 0) {
        asset.isAttachmentsRequired = true;
        isValid = false;
      } else {
        asset.isAttachmentsRequired = false;
      }
    } else {
      asset.isAttachmentsRequired = false;
    }
    asset.isValid = isValid
    return { asset, isValid };
  }
  /// Added this "validateAsset" function for Bug 222637 fix. without this we have used the validation in "assetNumber-container", but it causes the Asynchronous issue for disposition.
  const validateAsset = (asset: any) => {
    const error = JSON.parse(JSON.stringify(asset))
    let isValid = false;
    if (!error?.assetNumber) {
      error.assetError = "Please enter valid Asset #"
    } else if (error?.assetNumber?.length > 15) {
      error.assetError = "Please enter Asset number less than 15 digits."
    } else if (error.assetError?.length === 0) {
      error.assetError = "Click 'Get Asset Info' button to validate";
      isValid = true;
    }
    return { isValid, error };
  }

  const validateOdometerHourMeter = (asset: any) => {
    const error = JSON.parse(JSON.stringify(asset))
    if (!error.odometerHourMeter) {
      error.odometerHourMeterError = "Please enter " + getOdometerLabel(error);
    } else if (error.odometerHourMeter.length > 9) {
      error.odometerHourMeterError = "Please enter " + getOdometerLabel(error) + " less than 9 digits"
    } else {
      error.odometerHourMeterError = "";
    }
    return error;
  }

  const validateEstimatedDispositionPrice = (asset: any) => {
    const error = JSON.parse(JSON.stringify(asset))
    if (!error.estimatedDispositionPrice) {
      error.estimatedDispositionPriceError = "Please enter Estimated Disposition Price";
    } else if (error.estimatedDispositionPrice.length > 15) {
      error.estimatedDispositionPriceError = "Please enter less than 15 digits"
    } else {
      error.estimatedDispositionPriceError = "";
    }
    return error;
  }

  const validateOverallConditionComment = (asset: any) => {
    const error = JSON.parse(JSON.stringify(asset))
    if (error.conditionRating <= 3) {
      if (!error.conditionComment) {
        error.overallConditionCommentError = "Please enter overall condition comment";
      } else if (error.conditionComment.length > 200) {
        error.overallConditionCommentError = "Please enter less than 200 Characters"
      } else {
        error.overallConditionCommentError = "";
      }
    } else if (error.conditionComment && error.conditionComment.length > 200) {
      error.overallConditionCommentError = "Please enter less than 200 Characters";
    } else {
      error.overallConditionCommentError = "";
    }
    return error;
  }

  const validateOverallCondition = (asset: any) => {
    const error = JSON.parse(JSON.stringify(asset))
    if (error.conditionRating === 0 || error.conditionRating === undefined || error.conditionRating === null || error.conditionRating == '') {
      error.overallConditionError = "Please select at least one star";
    } else {
      error.overallConditionError = "";
    }
    return error;
  }

  const validateAssetStatus = (asset: any) => {
    const assetTemp = asset ? JSON.parse(JSON.stringify(asset)) : [];
    if (!assetTemp.assetStatus && assetTemp.showAssetStatus) {
      assetTemp.assetStatusError = "Please select Asset Status";
    } else {
      assetTemp.assetStatusError = "";
    }
    return assetTemp;
  }

  const checkIsNewlyaddedAsset = () => {
    let isNewlyaddedAsset = false;
    let addedAssetListNumbertemp: any = [];
    let assetListNumbertemp: any = [];
    let assetListTemp = assets?.length > 0 ? JSON.parse(JSON.stringify(assets)) : [];
    assetListTemp?.map((assetItem?: any) => {
      addedAssetListNumbertemp?.push(assetItem?.assetNumber)
    })
    dispatch(TransferAction.setAssetData(assetListTemp));
    assetDetailList?.map((assetdetailsItem?: any) => {
      assetListNumbertemp?.push(assetdetailsItem?.assetNumber)
    })
    if (addedAssetListNumbertemp?.length && assetListNumbertemp?.length) {
      if (JSON?.stringify(addedAssetListNumbertemp) != JSON?.stringify(assetListNumbertemp)) {
        isNewlyaddedAsset = true
      }
    }
    return isNewlyaddedAsset
  }

  const onClickAddAsset = () => {
    setIsAddAssetClicked(true)
    dispatch(RequisitionAction.setIsChangesOccured(true))
    let assetDetailListTemp: any = [];
    if(assets.length > 0){
      setIsGetAssetInfoClicked(true)
    }else{
      setIsGetAssetInfoClicked(false)
    }
    assetDetailList?.forEach((assetItem: any) => {
      let asset = Validate(assetItem);
        assetDetailListTemp.push(asset.asset);
    });
    setAssetDetailList(assetDetailListTemp);
    let isValid = true;
    assetDetailListTemp.forEach((assetItem: any) => {
      if (assetItem.assetError || assetItem.odometerHourMeterError || assetItem.estimatedDispositionPriceError || assetItem.overallConditionCommentError || assetItem.isAttachmentsRequired || assetItem.overallConditionError || (assetItem?.assetStatusError && assetItem?.showAssetStatus)) {
        isValid = false;
        return;
      }
    });
    if (isValid) {
      if (checkIsNewlyaddedAsset() && isValidForPenaltyFee(dispositionData?.assetDispositionChoice) && globalPenaltyFlag) {
        setShowWarningPopupOnUpdate(true)
        let payload: any = []
        assetDetailListTemp?.map((assetsListItem?: any) => {
          payload?.push({
            accountingClass: assetsListItem?.accountObject ? assetsListItem?.accountObject.toString() : '',
            aquisitionCode: assetsListItem?.acquisitionCode ? assetsListItem?.acquisitionCode.toString() : '',
            dateAcquired: assetsListItem?.dateAcquired ? Moment(assetsListItem?.dateAcquired).format("YYYY-MM-DD") : null,
            netBookedValue: assetsListItem?.netBookedValue ? parseInt(assetsListItem?.netBookedValue) : 0,
            disposeGainLoss: assetsListItem?.disposeGainLoss ? parseInt(assetsListItem?.disposeGainLoss) : 0,
            cost: assetsListItem?.acquisitionCost ? parseInt(assetsListItem?.acquisitionCost) : 0,
            assetNumber: assetsListItem?.assetNumber ? assetsListItem?.assetNumber.toString() : '',
            lifeMonths: assetsListItem?.lifeMonths ? parseInt(assetsListItem?.lifeMonths) : 0,
          })
        })
        dispatch(getDispositionPenaltyFee(payload))
      } else {
        updateAsset(assetDetailListTemp)
      }
      let isLeased = false;
        if(assets[0]?.leasedvsOwned == CONSTANTS.LEASED){
          isLeased = true
        }
        dispatch(getDispositionChoice(isLeased));
    } else {
      let popUpDecriptionTxt = "Please fill all the asset information details"
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: 'Validation',
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: popUpDecriptionTxt,
        primaryBtnText: "",
        outlineBtnText: "Close",
        popupOutlinebtnOnclick: () => {
          hideDialog();
        },
        isSingleConfirmationBtn: true,
      });
    }
  }

  useEffect(() => {
    // console.log('asset: ', state)
  }, [state])

  useEffect(()=>{
    setTimeout(() => {
      const elem = document.getElementsByClassName('item-details-requisition')[0] as HTMLElement;
      const top = elem?.offsetTop;
      document.getElementsByClassName('content-wrapper')[0].scrollTop = top - 10
    }, 100)
  },[Popupcontent.isDialogVisible])


  const isUploaded = (name: string) =>
    attachmentsList.find((x: any) => getFileName(x.attachmentUrl) === name);

  // To upload attachments
  const onUploadClick = (fileList: Array<File>) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    setError("");
    const filteredList = [
      ...fileList.filter((x) => !isUploaded(x.name || (x as any).fileName)),
    ];
    if (filteredList.length > 0 && filteredList.length <= 5) {
      setError("");
      let totalSize = 0;
      filteredList.forEach((file: File) => {
        totalSize = totalSize + (file.size || 0);
      });
      if (totalSize <= 5000000) {
        setError("");
        const formData = new FormData();
        formData.append("ContainerFolderName", "Order_Request_Attachments/" + uuid());

        for (let i = 0; i < filteredList.length; i++) {
          formData.append("Files", filteredList[i] as any);
        }
        dispatchUploadAttachments({ formData, filteredList, list: attachmentsList });
      } else {
        setError("Please Upload files without exceeding maximum size of 5MB");
      }
    } else if (fileList.length > 5) {
      setError(
        "Please Upload files without exceeding maximum limit of 5 files"
      );
    } else {
      if (fileList.length > 0 && !filteredList.length) {
        setError("All files are uploaded try to add new files");
      } else {
        setError("Choose at least 1 file to upload");
      }
    }
  };

  const onClicktLinkAttachment = (e: any, index: any) => {
    const attachmentButton: any = isAttachmentBtnClicked;
    attachmentButton[index] = !attachmentButton[index];
    setIsAttachmentBtnClicked(JSON.parse(JSON.stringify(attachmentButton)))
    e.preventDefault();
    e.stopPropagation();
  }

  const getLinkedAttachmentsCount = (asset: any) => {
    return asset.attachments?.length ? asset.attachments?.length : 0
  }

  useEffect(() => {
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    assetDetailListTemp.forEach((assetItem : any) => {
      getLinkedAttachmentsCount(assetItem)
    })
  }, [list])

  const onCloseLinkAttachment = (e: any) => {
    setIsAttachmentBtnClicked([])
    e.preventDefault();
    e.stopPropagation();
  }

  const onChangeLinkAttachment = (event: any, attachment: any, reason: any, index: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    event?.preventDefault();
    const asset = reason;
    if (event?.target?.checked) {
      if (!asset.attachments?.map((x: any) => x.fileName).includes(attachment.fileName)) {
        asset.attachments = [...(asset.attachments || []), attachment];
      }
    } else {
      asset.attachments = [
        ...asset.attachments.filter((x: any) => x.fileName !== attachment.fileName),
      ];
    }
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    assetDetailListTemp.forEach((assetItem : any) => {
      if (assetItem.assetIndex === asset.assetIndex) {
        assetItem.attachments = asset.attachments;
      }
    });
    setAssetDetailList(assetDetailListTemp)
    // dispatch(TransferAction.setAssetData(assetDetailListTemp))
  }

  const onRemoveClick = (index: number) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const findattachment = attachmentsList?.find((_attachment: any, i: any) => index === i);
    const assetArr = [];
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    if (findattachment) {
      assetDetailListTemp?.forEach((asset: any) => {
        const attachment = asset?.attachments;
        const findAttch = attachment?.find((attch: any) => attch?.fileName === findattachment?.fileName);
        if (findAttch) {
          assetArr.push(asset)
        }
      })
    }
    if (assetArr.length) {
      setError("The attachment file cannot be deleted. File linked to the item.");
    }
    else {
      const newArr = attachmentsList.slice();
      newArr.splice(index, 1);
      const assets = assetDetailListTemp?.map((asset: any) => {
        const attachments = asset?.attachments?.filter((attach: any) => !!newArr?.find((doc: any) => doc.fileName === attach.fileName))
        return { ...asset, attachments };
      })
      const newFileList = JSON.parse(JSON.stringify(list));
      newFileList.splice(index, 1);
      setList(newFileList);
      dispatch(TransferAction.setAssetData(assets));
      dispatchRemoveAttachment(newArr);
      setError("");
    }
  };

  const assetStatusList = [
    { value: "1", text: "Operable", key: "Operable" }, 
    { value: "2", text: "InOperable", key: "InOperable" }, 
    { value: "3", text: "Wrecked", key: "Wrecked" }
  ]

  const onRadioButtonChange = (event: any, item: any, asset: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
    assetDetailListTemp.forEach((assetItem : any) => {
      if (assetItem.assetIndex === asset.assetIndex) {
        assetItem.assetStatus = item.text;
        const errors = { ...validateAssetStatus(assetItem) };
        assetItem.assetStatusError = errors.assetStatusError;
        assetItem.isValid = Validate(assetItem).isValid;
        return
      }
    });
    setAssetDetailList(assetDetailListTemp);
  }

  return (
    <Informations
      onChangeOverallCondition={onChangeOverallCondition}
      attachmentsList={attachmentsList}
      assetDetailList={assetDetailList}
      onClickAdd={onClickAdd}
      onChangeOdometerHourMeter={onChangeOdometerHourMeter}
      onChangeEstimatedDispositionPrice={onChangeEstimatedDispositionPrice}
      onChangeOverallConditionComment={onChangeOverallConditionComment}
      priceFormat={priceFormat}
      onClickDelete={onClickDelete}
      onClickAddAsset={onClickAddAsset}
      onUploadClick={onUploadClick}
      error={error}
      setError={setError}
      assetDetails={assetDetails}
      getLinkedAttachmentsCount={getLinkedAttachmentsCount}
      onClicktLinkAttachment={onClicktLinkAttachment}
      isAttachmentBtnClicked={isAttachmentBtnClicked}
      onCloseLinkAttachment={onCloseLinkAttachment}
      onChangeLinkAttachment={onChangeLinkAttachment}
      list={list}
      setList={setList}
      onRemoveClick={onRemoveClick}
      dispositionData={dispositionData}
      docList={docList}
      getOdometerLabel={getOdometerLabel}
      getVinSerialLabel={getVinSerialLabel}
      assets={assets}
      Popupcontent={Popupcontent}
      hideDialog={hideDialog}
      popupOutlinebtnOnclick={popupOutlinebtnOnclick}
      addNewAssetAlert={addNewAssetAlert}
      hideDialogAsset={hideDialogAsset}
      DispositionAssetFieldRef={DispositionAssetFieldRef}
      setAssetDetailList={setAssetDetailList}
      setIsAssetBtnClicked={setIsAssetBtnClicked}
      isAssetBtnClicked={isAssetBtnClicked}
      setIsAsserNumberValid = {setIsAsserNumberValid}
      isAddAssetClicked = {isAddAssetClicked}
      setIsAddAssetClicked = {setIsAddAssetClicked}
      showDispositionInfoAlert = {showDispositionInfoAlert}
      setShowDispositionInfoAlert = {setShowDispositionInfoAlert}
      hideDialogAddDisposition={hideDialogAddDisposition}
      isGetAssetInfoCicked={isGetAssetInfoCicked}
      wrapperRef={wrapperRef}
      WarningPopupcontent = {WarningPopupcontent}
      warningHideDialog = {warningHideDialog}
      globalPenaltyFlag={globalPenaltyFlag}
      assetStatusList = {assetStatusList}
      onRadioButtonChange = {onRadioButtonChange}
      isHourMeterField={isHourMeterField}
      formatOdometerOnBlur={formatOdometerOnBlur}
    />
  )

}


export default InformationContainer